module.exports = __webpack_public_path__ + "img/nsitf-icon.aa69dc75.svg";